<template>
    <div
        v-show="open"
        ref="modalRoot"
        class="relative z-50"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
        @keydown.esc="$emit('close')"
        tabindex="0"
    >
        <div class="fixed inset-0 bg-black/70 transition-opacity"></div>

        <div class="fixed inset-0 z-10 overflow-y-auto">
            <div class="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0 sm:w-full">
                <div
                    class="relative w-11/12 transform overflow-hidden rounded-lg bg-gray-800 text-left shadow-xl transition-all
                           sm:my-8 sm:w-1/3 sm:w-2xl">
                    <slot name="close">
                        <button
                            type="button"
                            @click="$emit('close')"
                            class="close-modal"
                        >
                            <span class="material-symbols-outlined">close</span>
                        </button>
                    </slot>
                    <div class="bg-gray-800 px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                        <div class="text-center sm:mt-0 sm:text-left">
                            <h3 class="text-1xl text-left font-semibold leading-6 text-gray-200 sm:text-2xl" id="modal-title">
                                {{ heading }}
                            </h3>
                            <div class="mt-8">
                                <slot class="text-sm text-gray-200">
                                    <!-- {{ body }} -->
                                </slot>
                            </div>
                        </div>
                    </div>
                    <div class="bg-gray-800 px-4 py-4 border-t border-gray-700 sm:flex sm:flex-row-reverse sm:ml-auto">
                        <slot name="buttons">
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import { ref, watch, nextTick } from 'vue';

// Generic dialog shell: overlay, close button, heading, body and a buttons area
export default {
    props: {
        open: {
            type: Boolean,
            default: false,
        },
        heading: String,
    },
    emits: ['close'],
    setup(props) {
        const modalRoot = ref(null);

        // The Esc-to-close handler below is bound to this component's own root element, so it
        // only ever fires while that element (or something inside it) actually has focus - it
        // doesn't just because the modal is visible. Nothing was moving focus there, so opening
        // the modal left focus on whatever triggered it, and Esc silently did nothing.
        watch(() => props.open, async (isOpen) => {
            if (isOpen) {
                await nextTick();
                modalRoot.value?.focus();
            }
        });

        return { modalRoot };
    },
};
</script>

<style lang="postcss">
button.close-modal {
    @apply absolute right-2 top-4 flex items-center justify-center w-8 h-8 text-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-white sm:right-3 sm:top-6;
}
</style>